import React from 'react'
import './Loader.css'

function Loader() {
  return (
    <div className='loader'>
       <h1>Loading...</h1>
    </div>
  )
}

export default Loader